export default __webpack_public_path__ + "static/media/ox.f5ff385f.png";